import "./AcademicsPage.css";

function CoursesOffered() {
  return (
    <div className="courses-page">

      {/* UG PROGRAMS */}

      <h1>Undergraduate Programs (UG)</h1>

      <p>
        Our Undergraduate Programs are designed to provide strong academic foundations,
        practical exposure, and career-oriented knowledge across science, commerce,
        management, and computer applications.
      </p>

      <h2>Bachelor of Science (B.Sc.)</h2>

      <h3>MPC (Mathematics, Physics, Chemistry)</h3>
      <p>
        This program builds a strong foundation in core scientific principles. Students
        gain analytical, problem-solving, and quantitative skills. It prepares graduates
        for careers in engineering, research, defense services, data analysis, and higher
        education in science and technology.
      </p>

      <h3>MPCs (Mathematics, Physics, Computer Science)</h3>
      <p>
        A blend of physical sciences and computing, this course develops programming
        skills along with mathematical and physical concepts. It is ideal for students
        aiming for careers in software development, data science, research, and technical
        fields.
      </p>

      <h3>MSCs (Mathematics, Statistics, Computer Science)</h3>
      <p>
        This interdisciplinary program focuses on mathematical modeling, statistical
        analysis, and computational techniques. Students gain expertise useful in data
        analytics, banking, actuarial science, IT industries, and research organizations.
      </p>

      <h3>BZC (Botany, Zoology, Chemistry)</h3>
      <p>
        This life sciences program provides in-depth knowledge of plant science, animal
        biology, and chemical processes. It prepares students for careers in environmental
        science, agriculture, biotechnology, laboratory research, and higher studies in
        life sciences.
      </p>

      <h3>ZC Nutrition (Zoology, Chemistry, Nutrition)</h3>
      <p>
        This program combines biological sciences with nutritional studies. Students learn
        about human health, diet planning, food science, and wellness management. It opens
        career opportunities in nutrition consultancy, healthcare, food industries, and
        public health sectors.
      </p>

      <h3>MS AI & ML (Mathematics, Statistics, Artificial Intelligence & Machine Learning)</h3>
      <p>
        This modern interdisciplinary program introduces students to Artificial Intelligence,
        Machine Learning, statistics, and advanced computing concepts. Students develop
        practical skills in data analysis, AI technologies, programming, and intelligent
        systems, preparing them for careers in emerging technology industries.
      </p>

      <h2>Bachelor of Commerce (B.Com.)</h2>

      <h3>B.Com (General)</h3>
      <p>
        This program offers comprehensive knowledge in accounting, taxation, business law,
        economics, and finance. It prepares students for careers in banking, accounting,
        auditing, entrepreneurship, and professional courses like CA, CMA, and MBA.
      </p>

      <h3>B.Com (Computers)</h3>
      <p>
        An advanced commerce program integrating accounting and finance with computer
        applications. Students gain practical skills in Tally, business analytics, and
        computerized accounting systems, making them industry-ready for corporate and
        IT-enabled business roles.
      </p>

      <h3>B.Com (Computer Applications - Honours)</h3>
      <p>
        This honours program combines commerce subjects with advanced computer applications,
        accounting software, business technologies, and practical industry skills. It prepares
        students for careers in finance, corporate management, IT-enabled services, and
        higher professional education.
      </p>

      <h2>Bachelor of Business Administration (BBA)</h2>

      <h3>BBA (General)</h3>
      <p>
        The BBA General program develops managerial, leadership, and entrepreneurial skills.
        Students learn business management, marketing, human resources, finance, and
        organizational behavior. It prepares graduates for corporate careers and higher
        studies like MBA.
      </p>

      <h3>BBA (Business Analytics)</h3>
      <p>
        This specialization focuses on data-driven business decision-making, analytics,
        management strategies, and modern business technologies. Students gain analytical
        and leadership skills useful in corporate management and business intelligence roles.
      </p>

      <h2>Bachelor of Computer Applications (BCA)</h2>
      <p>
        The BCA program focuses on software development, programming languages, database
        management, networking, and web technologies. It equips students with strong
        technical skills required for careers in IT industries, software companies,
        and startups.
      </p>


      {/* PG PROGRAMS (UNCHANGED) */}

      <h1>Postgraduate Program (PG)</h1>

      <h2>Master of Science (M.Sc.) in Organic Chemistry</h2>

      <p>
        Our M.Sc. Organic Chemistry program provides advanced knowledge in organic
        synthesis, reaction mechanisms, spectroscopy, and research methodologies.
        The program emphasizes laboratory training, research orientation, and
        industry-relevant skills to prepare students for careers in research,
        pharmaceuticals, academia, and chemical industries.
      </p>

    </div>
  );
}

export default CoursesOffered;